import { Component, Input } from '@angular/core';
import { ListProviderOffice } from 'app/core/models/list-provider-office.model';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { ProviderOfficeAssociationNotesComponent } from '../../../shared/components/provider-office-association-notes/provider-office-association-notes.component';
import { ProviderOfficeFaxStatusPipe } from '../../../shared/pipes/provider-office-fax-status.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-provider',
    templateUrl: './provider.component.html',
    styleUrls: ['./provider.component.scss'],
    imports: [FaIconComponent,
              CopyToClipboardComponent,
              ProviderOfficeAssociationNotesComponent,
              ProviderOfficeFaxStatusPipe,
              BlankValueDashPipe]
})
export class ProviderComponent {
  @Input()
  provider: {
    npi: string;
    name: string;
    specialty: string;
    relevantProviderOffice: ListProviderOffice;
  };
  @Input() showFaxStatus = false;

  constructor() {}

  onNoteClick($event) {
    $event.preventDefault();
  }
}
